
import React from 'react';
import { Image, Alert } from 'react-bootstrap';

import Button from 'src/components/button';
import { Link } from 'react-router-dom';

import cx from 'classnames';

import { toast } from 'react-toastify';
import _ from 'lodash';
import AuthService from 'src/services/auth.service';
import { parse } from 'papaparse';

import CSVImport from '../images/csvImport.svg';
import AlertMessageIcon from 'src/legacy/images/alert_message.png'
import { localizedStrings } from 'src/localization';
import styles from './Style.module.scss';
import Toast from 'src/components/toast';
import Text from 'src/components/text';

class ContactsImportView extends React.Component {
  constructor(props) {
    super(props);

    this.errorMessage = null;
    this.imported = 0;
    this.totalContacts = 0;

    this.state = {
      importProgress: false,
      errorMessage: null,
      displayWarning: true,
      isFileFormatError: false
    }

    this._handleCSVImport = this._handleCSVImport.bind(this);
    this._handleImportClicked = this._handleImportClicked.bind(this);
    this.containsEmail = this.containsEmail.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizatedSettings = localizedStrings.pages.settings;
    this.localizedDistributionList = this.localizatedSettings.distribution_lists;
    this.localizedEmptyMessage = this.localizedDistributionList.sliders.add_contacts.empty_message;
    this.localizedUploadCsv = this.localizedDistributionList.sliders.add_contacts.upload_csv;
    this.localizedtoast = this.localizatedSettings.toast;
    
  }


  _validateEmail(email) {
    email = email.replace(/\s/g, " ");
    
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


    if (!email || email.trim() == '') {
      return this.localizedEmptyMessage.name;
    }

    if (!regex.test(email)) {
      return this.localizedEmptyMessage.name;
    }

    else return null;
  }

  _handleCSVImport(e) {
    parse(e.target.files[0], {
      header: true,
      complete: (results) => {
        var contacts = results.data
         if (contacts.length == 0) {
          this.setState({
            errorMessage: this.localizedUploadCsv.no_contacts
          });
        } 
        else if(_.size(contacts) > 0 && !this.containsEmail(contacts)){
          this.setState({
            isFileFormatError: true,
          })
        }
        else {
          this.setState({
            contacts: contacts
          });
        }
      }
    });
  }

  _handleImportClicked() {
    if (!this.state.contacts || this.state.contacts.length == 0) {
      this.setState({
        errorMessage: this.localizedUploadCsv.no_contacts
      });

      return;
    }

    this.setState({
      displayWarning: false
    });

    var contacts = this.state.contacts.slice(0,(100 - this.props.contactCount));

    contacts.filter(contact => {
      return this._validateEmail(contact.EMAIL) == null;
    });

    var length = contacts.length;
    var batchSize = 25;
    var batchPages = Math.ceil(length / batchSize);
    var importTask = Promise.resolve();

    this.setState({
      progress: {
        page: 0,
        batchSize: batchSize,
        total: length
      }
    })

    const tasks = [];

    for (let index = 0; index < batchPages; index++) {
      var cloned = [...contacts];
      var emailsClone = [...contacts];
      var contactsBatch = cloned.splice(index * batchSize, batchSize).map(contact => {
        var request = {}
        request.email = contact.EMAIL;

        if (contact.FIRSTNAME) {
          request.firstName = contact.FIRSTNAME;
        }

        if (contact.LASTNAME) {
          request.lastName = contact.LASTNAME;
        }

        if (contact.COMPANY) {
          request.company = contact.COMPANY;
        }

        if (contact.TITLE) {
          request.title = contact.TITLE;
        }

        return request;
      });

      let contactList = {};
      let emails = [];
      var emailsBatch = emailsClone.splice(index * batchSize, batchSize).map(contact => {
        var request = {};
        request.email = contact.EMAIL;
        return request;
      });
      emails = emailsBatch.map((email)=>{
        return email.email;
      })

      contactList.emails = emails;

      tasks.push({
        contacts: contactsBatch,
        index: index,
        execute: (task) => {
          return this.props.importContacts(task.contacts).then(response => {
            if (response.type === 'LEGACY_IMPORTING_CONTACTS_SUCCEDDED') {
              this.setState({
                progress: {
                  page: task.index + 1,
                  batchSize: batchSize,
                  total: length
                }
              })
            }
          })
        }
      });
      if (this.props.contactList){
        tasks.push({
          contacts: contactList,
          index: index,
          execute: (task) => {
            return this.props.updateContactList(this.props.contactList.id, task.contacts).then(response => {
              if (response.type === 'LEGACY_UPDATING_CONTACT_LIST_SUCCEDDED') {
                this.props.navigate(`/settings/contact_list/${this.props.contactList.id}`)
              }
            });
          }
        });
      }
    }

    tasks.push({
      execute: (task) => {
        toast(
          <Toast.Sucess
            message={localizedStrings.formatString(this.localizedtoast.contacts_imported.success, length)}
          />,
          {
            autoClose: 3000
          });

        this.props.handleCancelClick();
      }
    });

    tasks.reduce((previousPromise, nextTask) => {
      return previousPromise.then(() => {
        return nextTask.execute(nextTask)
      });
    }, importTask);
  }

  _handleCancelClick() {
    this.props.handleCancelClick();
  }

  _handleBackClick() {
    this.props.handleBackClick();
  }

  _renderUploadView() {
    return (
      <div className={cx(styles.uploadView)}>
        <span className={styles.backButton} onClick={() => { this._handleBackClick() }}><i className='paperflite-back-arrow'></i> BACK</span>
        <section className={cx(styles.section, styles.displaySection)}>
          <ul className={styles.sectionHeader}>
            <li className={styles.icon}><span className="paperflite-upload"></span></li>
            <li className={styles.name}>
              {this.localizedUploadCsv.title}
              <p>{this.localizedUploadCsv.sub_text}</p>
            </li>
            <li className={styles.browseIcon}>
              <span className={cx(styles.browse, {
                [styles.disabled]: this.state.isFileFormatError
              })}>{this.localizedCommonActions.upload}</span>
              <input className="file-input-hidden" type="file" id="uploadCSV" accept=".csv"
                disabled={this.state.isFileFormatError}
                onClick={(e) => { e.target.value = '' }}
                onChange={this._handleCSVImport}></input>
            </li>
          </ul>
        </section>

        <div className={styles.csvPlaceholder}>
          <Image src={CSVImport} />
        </div>

        <div className={styles.message}>
          {this.localizedUploadCsv.description}
        </div>
        <div className={styles.downloadLink}>
          <Link to={AuthService.getURL(`api/2.0/contacts/downloadTemplate`)} target="_blank" >
            <i className="paperflite-download"/>
          {this.localizedUploadCsv.download_action}
        </Link>
        </div>
        <div>
          {this.state.errorMessage &&
            <Alert bsStyle="danger" className={(styles.errorMessage)} isOpen={this.state.errorMessage}>
              <Image className={styles.alertImage} src={AlertMessageIcon} />
              <div className={styles.alertText}>
                {this.state.errorMessage}
              </div>
            </Alert>
          }
          {this.state.isFileFormatError && <Alert
            bsStyle="danger"
            className={cx(styles.fileFormatErrorMessage)}
            onDismiss={() => this.setState({ isFileFormatError: false })}
          >
            <button
              className={styles.dismissButton}
              onClick={() => this.setState({ isFileFormatError: false })}
            >
              <span className="lnr lnr-cross"></span>
            </button>
            <Image
              className={styles.alertImage}
              src={AlertMessageIcon}
            />
            <div className={styles.alertText}>
              {this.localizedDistributionList.file_format_error}
            </div>
          </Alert>}
        </div>
      </div>
    );
  }

  _renderContacts(contacts) {
    var rows = Array();
    var newContacts = contacts.slice(0,(100 - this.props.contactCount));
    
    newContacts.forEach((contact) => {
      if(contact.EMAIL)
      {
        this.errorMessage =  this._validateEmail(contact.EMAIL);

        rows.push(
          <span>
            <div className={cx(styles.contact, { [styles.invalid]: this.errorMessage })}>
              <div className={styles.left}>
                <div className={styles.contactAvatar}>
                  <i className='paperflite-user-settings'/>
                </div>
              </div>
                   <Text className={styles.contactName} text={contact.EMAIL} lines={1} />
            </div>
          </span>
        )
      }
    });

    return rows;
  }

  _renderImportStatus() {
    if (!this.state.progress) {
      return;
    }

    const page = this.state.progress.page;
    const batchSize = this.state.progress.batchSize;
    const total = this.state.progress.total;

    const progress = Math.min(((page + 1) * batchSize), total);

    return (
      <div className={styles.status}>
        <div className={styles.description}>
          <span>{localizedStrings.formatString(this.localizedUploadCsv.progress, 
          <span className={styles.statusCount}>{progress}</span>, 
          <span className={styles.statusCount}>{total}</span>)} 
          </span>
        </div>
      </div>
    );
  }

  containsEmail(contacts){
    const isEmailExists = _.some((contacts), obj => _.has(obj, 'EMAIL'));
    return isEmailExists;
  }

  render() {
    if (!this.state.contacts || this.state.contacts.length == 0) {
      return this._renderUploadView();
    }

    return (
      <div className={styles.content}>
        <div className={styles.header}>
          <h4>{this.localizedUploadCsv.upload_contacts} ({this.state.contacts.slice(0,(100 - this.props.contactCount)).length})</h4>
          <p>{this.localizedDistributionList.sub_text}</p>
        </div>
        <div className={styles.contactsScroll}>
          {this._renderContacts(this.state.contacts)}
        </div>
      
     
        <div className={styles.actions}>
        {this.state.displayWarning &&
          <Alert className={styles.alertMessage} variant='warning'>
            {this.localizedUploadCsv.note}
          </Alert>
        }
        {this._renderImportStatus()}

        <div className={styles.buttonTray}>

          <Button
          text={this.state.progress ? this.localizedCommonActions.importing : this.localizedCommonActions.import}
            variant='primary'
            onClick={() => { this._handleImportClicked() }}
            title={this.state.progress ? this.localizedCommonActions.importing : this.localizedCommonActions.import}
            primary
            className={styles.send}
            disabled={this.state.progress || this.state.errorMessage}
          />
          <Button
            text={this.localizedCommonActions.cancel}
            onClick={() => { this._handleCancelClick() }}
            disabled={this.state.progress}
            />
        </div>
        </div>
      </div>
    );
  }
}

export default ContactsImportView;